import { ToastContainer } from "react-toastify";

// formik components
import { Form, Formik } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// NewUser layout schemas for form and form feilds
import axios from "axios";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { URL_API } from "config";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import initialValues from "./schemas/InitialValues";
import validations from "./schemas/Validations";
import form from "./schemas/Form";
import CooperatedFormMessages from "./update-steps/CooperatedFormMessages";
import CooperatedFormCollaborator from "./update-steps/CooperatedFormCollaborator";
import CooperatedFormDocs from "./update-steps/CooperatedFormDocs";
import CooperatedFormData from "./update-steps/CooperatedFormData";
import CooperatedFormContacts from "./update-steps/CooperatedFormContacts";
import CooperatedFormAddress from "./update-steps/CooperatedFormAddress";
import CooperatedFormIncome from "./update-steps/CooperatedFormIncome";
import CooperatedFormDescription from "./update-steps/CooperatedFormDescription";
import {
  genderNumber,
  contactTypeNumber,
  statusToNumber,
  documentNumber,
  validateCooperatedFields,
} from "utils/functions";
import { useAuthContext } from "context/AuthContext";
import { Box, CircularProgress, Modal } from "@mui/material";

const payload = {
  full_name: "",
  social_name: "",
  cpf: "",
  birth_date: "",
  document_number: "",
  issuing_body: "",
  document_uf: "",
  gender: 1,
  document_type: 1,
  pa_id: "",
  status: 1,
  complement: "",
  issue_date: "",
  nationality: "",
  birth_city: "",
  birth_uf: "",
  mothers_name: "",
  fathers_name: "",
  email: "",
  phone: "",
  contact: "",
  cep: "",
  street: "",
  number: "",
  state: "",
  neighborhood: "",
  city: "",
  mailing_address: "",
  income: "R$ 0,00",
  contact_type: 2,
  private_description: "",
  reason_reprovation: "",
  account_number: "",
  situation_document: "",
  hiring_type: 1,
  responsible_email: "",
};

export default function UpdateFormCooperated() {
  const { formId } = form;

  const { uuid } = useParams();

  const [cooperated, setCooperated] = useState(payload);

  const [open, setOpen] = useState(false);

  const [income, setIncome] = useState();
  const [gender, setGender] = useState(1);
  const [docType, setDocType] = useState(1);
  const [contactType, setContactType] = useState(1);

  const [street, setStreet] = useState("");
  const [state, setState] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [city, setCity] = useState("");

  const [pas, setPas] = useState([]);
  const [pa, setPa] = useState("");
  const [status, setStatus] = useState("");
  const [situationDocument, setSituationDocument] = useState("");
  const [reason, setReason] = useState("");
  const [identificationDocument, setIdentificationDocument] = useState([]);
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [addressProof, setAddressProof] = useState([]);
  const [incomeProof, setIncomeProof] = useState([]);
  const [subscriptionCard, setSubscriptionCard] = useState([]);

  const currentValidation = validations[0];

  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const response = await axios.get(URL_API + `/cooperated/${uuid}`, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      });

      setStreet(response?.data.street);
      setState(response?.data.state);
      setNeighborhood(response?.data.neighborhood);
      setCity(response?.data.city);
      setIncome(response?.data.income);
      setContactType(response?.data.contact_type);
      setDocType(response?.data.document_type);
      setGender(response?.data.gender);

      switch (response?.data?.situation_document) {
        case 1:
          setSituationDocument("Liberada");
          break;
        case 5:
          setSituationDocument("Restrita");
          break;
        default:
          break;
      }

      switch (response?.data?.reason_reprovation) {
        case "1":
          setReason("Inconsistência de dados");
          break;
        case "2":
          setReason("Prazo de envio de documentos excedido");
          break;
        case "3":
          setReason("Já é cooperado");
          break;
        default:
          break;
      }

      switch (response?.data?.status) {
        case 1:
          setStatus("Em aberto");
          break;
        case 2:
          setStatus("Iniciado");
          break;
        case 3:
          setStatus("Em análise");
          break;
        case 4:
          setStatus("Documentos pendentes");
          break;
        case 5:
          setStatus("Em processo admissão");
          break;
        case 6:
          setStatus("Aprovado");
          break;
        case 7:
          setStatus("Reprovado");
          break;
        case 8:
          setStatus("Aguardando Assinatura");
          break;
        case 10:
          setStatus("Finalização Cadastral");
          break;
        default:
          break;
      }

      setCooperated(response?.data);

      setIdentificationDocument(response?.data.documents.dock);
      setIncomeProof(response?.data.documents.income);
      setMaritalStatus(response?.data.documents.marital);
      setAddressProof(response?.data.documents.proof);
      setSubscriptionCard(response?.data.documents.signature);

      const responsePas = await axios.get(URL_API + `/pas?page=1&limit=500`, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      });

      setPas(responsePas?.data?.data);

      setPa(
        responsePas?.data?.data?.filter(
          (obj) => obj?.uuid === response?.data.pa_id
        )[0]
      );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (_, __) => {
    const validate = validateCooperatedFields({
      ...cooperated,
      pa_id: pa?.uuid,
      street,
      state,
      neighborhood,
      city,
    });

    if (validate) {
      try {
        setOpen(true);
        const data = new FormData();

        if (cooperated) {
          data.append("full_name", cooperated?.full_name);
          data.append("social_name", cooperated?.social_name);
          data.append("cpf", cooperated?.cpf);
          data.append("birth_date", cooperated?.birth_date);
          data.append("document_number", cooperated?.document_number);
          data.append("issuing_body", cooperated?.issuing_body);
          data.append("document_uf", cooperated?.document_uf);
          data.append("issue_date", cooperated?.issue_date);
          data.append("nationality", cooperated?.nationality);
          data.append("birth_city", cooperated?.birth_city);
          data.append("birth_uf", cooperated?.birth_uf);
          data.append("mothers_name", cooperated?.mothers_name);
          data.append("fathers_name", cooperated?.fathers_name);
          data.append("email", cooperated?.email);
          data.append("phone", cooperated?.phone);
          data.append("contact", cooperated?.contact);
          data.append("cep", cooperated?.cep);
          data.append("number", cooperated?.number);
          data.append("complement", cooperated?.complement);
          data.append("mailing_address", cooperated?.mailing_address);
          data.append("hiring_type", cooperated?.hiring_type);
          data.append("responsible_email", cooperated?.responsible_email);
          data.append("private_description", cooperated?.private_description);
          data.append("account_number", cooperated?.account_number);
        }
        data.append("street", street);
        data.append("state", state);
        data.append("neighborhood", neighborhood);
        data.append("city", city);
        data.append("gender", genderNumber(gender));
        data.append("income", income);
        data.append("contact_type", contactTypeNumber(contactType));
        data.append("pa_id", pa?.uuid);
        data.append("status", statusToNumber(status));
        data.append("document_type", documentNumber(docType));

        // Append files
        const appendFiles = (fieldName, files) => {
          if (files && files.length) {
            files.forEach((file) => file.size && data.append(fieldName, file));
          }
        };

        // Adiciona os arquivos ao FormData
        appendFiles("identification_document", identificationDocument);
        appendFiles("marital_status", maritalStatus);
        appendFiles("address_proof", addressProof);
        appendFiles("income_proof", incomeProof);
        appendFiles("subscription_card", subscriptionCard);

        const response = await axios.put(
          `${URL_API}/cooperateds/${uuid}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${tag}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          toast.success("Colaborador atualizado com sucesso");

          setOpen(false);

          navigate(
            user?.profile === 99
              ? "/admin/acompanhamento"
              : "/admin/colaboradores"
          );
        }
      } catch (error) {
        setOpen(false);

        toast.error(error?.message || "Ocorreu um erro");
      }
    } else {
      setOpen(false);
    }
  };

  const setInput = (e) => {
    const { name, value } = e.target;
    setCooperated((prev) => ({ ...prev, [name]: value }));
  };

  const orderFormToReturn = () => {
    if (user?.profile === 99) {
      return (
        <>
          {/* Colaborador */}
          <CooperatedFormCollaborator
            label="1/8 - Colaborador"
            cooperated={cooperated}
            setInput={setInput}
          />

          {/* Docs */}
          <CooperatedFormDocs
            label="2/8 - Documentos"
            identificationDocument={identificationDocument}
            setIdentificationDocument={setIdentificationDocument}
            maritalStatus={maritalStatus}
            setMaritalStatus={setMaritalStatus}
            addressProof={addressProof}
            setAddressProof={setAddressProof}
            incomeProof={incomeProof}
            setIncomeProof={setIncomeProof}
            subscriptionCard={subscriptionCard}
            setSubscriptionCard={setSubscriptionCard}
          />

          {/* Dados */}
          <CooperatedFormData
            label="3/8 - Dados"
            cooperated={cooperated}
            setInput={setInput}
            gender={gender}
            setGender={setGender}
            docType={docType}
            setDocType={setDocType}
          />

          {/* Contatos */}
          <CooperatedFormContacts
            label="4/8 - Contatos"
            cooperated={cooperated}
            contactType={contactType}
            setContactType={setContactType}
            setInput={setInput}
          />

          {/* Endereço */}
          <CooperatedFormAddress
            label="5/8 - Endereço"
            cooperated={cooperated}
            street={street}
            setStreet={setStreet}
            state={state}
            setState={setState}
            neighborhood={neighborhood}
            setNeighborhood={setNeighborhood}
            city={city}
            setCity={setCity}
            setInput={setInput}
          />

          {/* Renda */}
          <CooperatedFormIncome
            label="6/8 - Renda"
            income={income}
            setIncome={setIncome}
          />

          {/* Descrição */}
          <CooperatedFormDescription
            label="7/8 - Descrição"
            cooperated={cooperated}
            pas={pas}
            pa={pa}
            setPa={setPa}
            status={status}
            setStatus={setStatus}
            setInput={setInput}
            situationDocument={situationDocument}
            setSituationDocument={setSituationDocument}
            reason={reason}
            setReason={setReason}
          />

          {/* Mensagens */}
          <CooperatedFormMessages label="8/8 - Mensagens" />
        </>
      );
    }

    return (
      <>
        {/* Mensagens */}
        <CooperatedFormMessages label="1/8 - Mensagens" />

        {/* Colaborador */}
        <CooperatedFormCollaborator
          label="2/8 - Colaborador"
          cooperated={cooperated}
          setInput={setInput}
        />

        {/* Docs */}
        <CooperatedFormDocs
          label="3/8 - Documentos"
          identificationDocument={identificationDocument}
          setIdentificationDocument={setIdentificationDocument}
          maritalStatus={maritalStatus}
          setMaritalStatus={setMaritalStatus}
          addressProof={addressProof}
          setAddressProof={setAddressProof}
          incomeProof={incomeProof}
          setIncomeProof={setIncomeProof}
          subscriptionCard={subscriptionCard}
          setSubscriptionCard={setSubscriptionCard}
        />

        {/* Dados */}
        <CooperatedFormData
          label="4/8 - Dados"
          cooperated={cooperated}
          setInput={setInput}
          gender={gender}
          setGender={setGender}
          docType={docType}
          setDocType={setDocType}
        />

        {/* Contatos */}
        <CooperatedFormContacts
          label="5/8 - Contatos"
          cooperated={cooperated}
          contactType={contactType}
          setContactType={setContactType}
          setInput={setInput}
        />

        {/* Endereço */}
        <CooperatedFormAddress
          label="6/8 - Endereço"
          cooperated={cooperated}
          street={street}
          setStreet={setStreet}
          state={state}
          setState={setState}
          neighborhood={neighborhood}
          setNeighborhood={setNeighborhood}
          city={city}
          setCity={setCity}
          setInput={setInput}
        />

        {/* Renda */}
        <CooperatedFormIncome
          label="7/8 - Renda"
          income={income}
          setIncome={setIncome}
        />

        {/* Descrição */}
        <CooperatedFormDescription
          label="8/8 - Descrição"
          cooperated={cooperated}
          pas={pas}
          pa={pa}
          setPa={setPa}
          status={status}
          setStatus={setStatus}
          setInput={setInput}
          situationDocument={situationDocument}
          setSituationDocument={setSituationDocument}
          reason={reason}
          setReason={setReason}
        />
      </>
    );
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox lineHeight={0} sx={{ mt: 8, mb: 4 }}>
          <MDTypography variant="h5">Colaborador</MDTypography>
          <MDTypography variant="button" color="text">
            Informações obrigatórias *
          </MDTypography>
        </MDBox>

        <MDBox mb={5}>
          <Grid sx={{ height: "100%" }}>
            <Grid item xs={12} lg={8}>
              <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
              >
                <Form id={formId} autoComplete="off">
                  {/* Forms */}
                  {orderFormToReturn()}

                  <MDBox
                    mt={2}
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <MDButton
                      variant="gradient"
                      color="light"
                      onClick={() => {
                        console.log(user?.profile === 99
                          ? "/admin/acompanhamento"
                          : "/admin/colaboradores");

                        navigate(
                          user?.profile === 99
                            ? "/admin/acompanhamento"
                            : "/admin/colaboradores"
                        );
                      }}
                    >
                      Voltar
                    </MDButton>

                    <MDButton
                      type="submit"
                      variant="gradient"
                      disabled={open}
                      color="dark"
                      onClick={handleSubmit}
                    >
                      Salvar
                    </MDButton>
                  </MDBox>
                </Form>
              </Formik>
            </Grid>
          </Grid>
        </MDBox>

        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{
            overflow: "scroll",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Box sx={{ display: "flex", margin: "auto" }}>
            <CircularProgress color="success" size={80} />
          </Box>
        </Modal>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}
